module.exports = __webpack_public_path__ + "assets/education.8a144773.svg";